/** @jsx jsx */
import {jsx, Styled} from 'theme-ui'
import {Link} from "~components/Icons";

const heading = Tag => {
    const Component = props => {
        const permaLinkHandle = !!props.id && Tag !== 'h1' ? (
                <a
                    href={`#${props.id}`}
                    sx={{
                        color: 'inherit',
                        marginLeft: 2,
                        textDecoration: 'none',
                        ':hover': {
                            color: 'secondary',
                        },
                    }}
                >
                    <Link size={15} />
                </a>) : null;

        let tagContent = null;
        switch (Tag) {
            case 'h1' :
                tagContent = <Styled.h1 {...props}>{props.children}{permaLinkHandle}</Styled.h1>;
                break;
            case 'h2' :
                tagContent = <Styled.h2 {...props}>{props.children}{permaLinkHandle}</Styled.h2>;
                break;
            case 'h3' :
                tagContent = <Styled.h3 {...props}>{props.children}{permaLinkHandle}</Styled.h3>;
                break;
            case 'h4' :
                tagContent = <Styled.h4 {...props}>{props.children}{permaLinkHandle}</Styled.h4>;
                break;
            case 'h5' :
                tagContent = <Styled.h5 {...props}>{props.children}{permaLinkHandle}</Styled.h5>;
                break;
            case 'h6' :
                tagContent = <Styled.h6 {...props}>{props.children}{permaLinkHandle}</Styled.h6>;
                break;
            default :
                tagContent = <Styled.h1 {...props}>{props.children}{permaLinkHandle}</Styled.h1>;
                break;
        }

        return tagContent;
    }

    Component.displayName = Tag
    return Component
}

export const h1 = heading('h1')
export const h2 = heading('h2')
export const h3 = heading('h3')
export const h4 = heading('h4')
export const h5 = heading('h5')
export const h6 = heading('h6')